// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__duIWZ"};